import { onPatientDataChanged } from "@/services/patientDataBus";

/**
 * Mixin para os cards do dashboard do paciente.
 *
 * Faz o card recarregar (chamando seu próprio `fetchData`) sempre que QUALQUER
 * dado do paciente muda no app — inserir/editar/excluir em outro card ou numa
 * aba do drawer. Assim todos os cards ficam sincronizados sem cada um precisar
 * avisar os demais (o sinal vem do interceptor do http via patientDataBus).
 *
 * Requisito: o componente deve ter um método `fetchData()`.
 */
export default {
  created() {
    if (typeof this.fetchData === "function") {
      this._offPatientDataChanged = onPatientDataChanged(() => {
        this.fetchData();
      });
    }
  },
  beforeDestroy() {
    if (this._offPatientDataChanged) {
      this._offPatientDataChanged();
      this._offPatientDataChanged = null;
    }
  },
};
